/**
 * @deprecated
 * @type {{NORMAL: string; ADVANCED: string; }}
 */
export const AntiAliasType = {
    NORMAL: "normal",
    ADVANCED: "advanced"
};